import ButtonGallery from "@/components/Triggers/ButtonGallery";
import { allTxt2ImgArtists, ARTIST_IMAGES, Txt2ImgArtists } from "@/utils/constants";
import { Editor_Words } from "@/utils/lang/editor";
import { chakra } from "@chakra-ui/react";
import { langStore, translate } from "@noli/business";
import { observer } from "mobx-react-lite";
import React from "react";

const IArtistSelector: React.FC<{
  value: Txt2ImgArtists;
  setValue: (value: Txt2ImgArtists) => void;
  className?: string;
}> = ({ value, setValue, className }) => {
  return (
    <ButtonGallery
      className={className}
      textH={24}
      w="100%"
      mt="16px"
      panelTitle={translate(Editor_Words["txt2img-sd-artist-title"], langStore.tgt)}
      collections={allTxt2ImgArtists}
      images={ARTIST_IMAGES}
      storeValue={value}
      setStoreValue={setValue}
    />
  );
};

export const ArtistSelector = chakra(observer(IArtistSelector));
